export default __webpack_public_path__ + "static/media/NASA_04.0220f013.png";